import {Tr} from "@/i18n/i18n";
import {HorizontalStandardPanel} from "@/scenes.ui/horizontal-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SoundUtils from "@/utils/sound-utils";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import CU from "@/utils/c-u";


export class LawPanel extends HorizontalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, onAcceptCallback: () => void, onDeclineCallback: () => void) {
        super(scene, canvas, Tr('gdpr.title'));

        this.setDepth(3000);

        let clickSound = SoundUtils.addSound(scene, Keys.SOUND_BUTTON_CLICK);

        let body = TextUtils.addTextByFamily(scene, Tr('gdpr.body'),
            0, -40, '#ffd465', 15, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let acceptButton = new SquareButton(scene, 0, 135, 0, Keys.UI_ART_GREEN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('gdpr.accept.button'), false, 80 * CU.S, 80 * CU.S);

        this.setOnCLoseCallback(onDeclineCallback);

        acceptButton.setCallback(() => {
            SoundUtils.play(clickSound);
            if (onAcceptCallback != null) {
                this.close();
                onAcceptCallback();
            }
        });

        this.add([body, acceptButton]);
    }
}